<div class="search-bar">
  <form class="search-form" (submit)="onSearchSubmit($event)">
    <input
      type="text"
      class="search-input"
      placeholder="Buscar produtos, marcas, veículos..."
      [value]="searchQuery()"
      (input)="onSearchInput($event)"
      (focus)="showSuggestions() && suggestions().length > 0 && showSuggestions.set(true)"
      (blur)="hideSuggestions()"
      autocomplete="off"
    />
    <button type="submit" class="search-button" aria-label="Buscar">
      @if (isLoading()) {
        <span class="loading-spinner-small"></span>
      } @else {
        <img src="assets/icons/search.svg" width="18" height="18" alt="Buscar" />
      }
    </button>
  </form>

  <!-- Sugestões de busca -->
  @if (showSuggestions() && suggestions().length > 0) {
    <div class="search-suggestions">
      @for (product of suggestions(); track product.id) {
        <div 
          class="suggestion-item"
          (mousedown)="selectSuggestion(product)"
        >
          <img 
            [src]="product.imagemURL" 
            [alt]="product.nome"
            class="suggestion-image"
          />
          <div class="suggestion-content">
            <div class="suggestion-name" [innerHTML]="highlightMatch(product.nome)"></div>
            <div class="suggestion-details">
              <span class="suggestion-price">{{ formatPrice(product.preco) }}</span>
              @if (product.estoque.saldo > 0) {
                <span class="suggestion-stock">Em estoque</span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (showSuggestions() && searchQuery().length >= 2 && suggestions().length === 0 && !isLoading()) {
    <div class="search-suggestions">
      <div class="suggestion-empty">
        Nenhum produto encontrado para "{{ searchQuery() }}"
      </div>
    </div>
  }
</div>

